<template>
  <div>
    <div class="right-header flex items-center">
      <!-- <div class="header-banner cursor-pointer" @click="showWelfareDialog = true"><img class="w-full" src="@/assets/img/welfare-free-banner-tag.png" alt="" /></div> -->
      <el-badge :value="notNumber" class="item cursor-pointer" v-if="administrationFlag" style="margin-right: 24px;">
        <img src="@/assets/img/new/message-icon.svg" @click="setup(7)" />
      </el-badge>
      <!-- 用户信息 -->
      <!-- <el-popover placement="bottom-end" width="400" trigger="hover">
        <div>123213</div>
        <div class="phone" slot="reference">
          <el-avatar v-if="imageUrl" style="margin-right: 10px" :size="32" :src="imageUrl" />
          <el-avatar v-else :size="32" style="margin-right: 10px">
            <div class="u-name w-full h-full" style="background-color: #0080ff;"
              v-if="fiveBodyId == 1 || fiveBodyId == 6">施</div>
            <div class="u-name w-full h-full" style="background-color: #ff7a00;" v-else-if="fiveBodyId == 2">建</div>
            <div class="u-name w-full h-full" style="background-color: #f2c615;" v-else-if="fiveBodyId == 3">监</div>
            <div class="u-name w-full h-full" style="background-color: #943dec;" v-else-if="fiveBodyId == 4">设</div>
            <div class="u-name w-full h-full" style="background-color: #00c14d;" v-else-if="fiveBodyId == 5">勘</div>
          </el-avatar>
        </div>
      </el-popover> -->
      <el-popover placement="bottomLeft" trigger="hover" :visible-arrow="false" popper-class="popover-message">
        <div class="phone" slot="reference">
          <el-avatar v-if="imageUrl" style="margin-right: 10px" :size="32" :src="imageUrl" />
          <el-avatar v-else :size="32" style="margin-right: 10px">
            <!-- <div class="u-name w-full h-full" style="background-color: #0080ff;"
              v-if="fiveBodyId == 1 || fiveBodyId == 6">施</div>
            <div class="u-name w-full h-full" style="background-color: #ff7a00;" v-else-if="fiveBodyId == 2">建</div>
            <div class="u-name w-full h-full" style="background-color: #f2c615;" v-else-if="fiveBodyId == 3">监</div>
            <div class="u-name w-full h-full" style="background-color: #943dec;" v-else-if="fiveBodyId == 4">设</div>
            <div class="u-name w-full h-full" style="background-color: #00c14d;" v-else-if="fiveBodyId == 5">勘</div> -->
            <div class="u-name w-full h-full" style="background-color: #0080ff;">{{ realname.substring(0, 1) }}</div>
          </el-avatar>
        </div>
        <div>
          <div>
            <div class="header-info flex items-center">
              <el-avatar v-if="imageUrl" style="margin-right: 10px" :size="32" :src="imageUrl" />
              <el-avatar v-else :size="32" style="margin-right: 10px">
                <!-- <div class="u-name w-full h-full" style="background-color: #0080ff;"
                  v-if="fiveBodyId == 1 || fiveBodyId == 6">施</div>
                <div class="u-name w-full h-full" style="background-color: #ff7a00;" v-else-if="fiveBodyId == 2">建</div>
                <div class="u-name w-full h-full" style="background-color: #f2c615;" v-else-if="fiveBodyId == 3">监</div>
                <div class="u-name w-full h-full" style="background-color: #943dec;" v-else-if="fiveBodyId == 4">设</div>
                <div class="u-name w-full h-full" style="background-color: #00c14d;" v-else-if="fiveBodyId == 5">勘</div> -->
                <div class="u-name w-full h-full" style="background-color: #0080ff;">{{ realname.substring(0, 1) }}</div>
              </el-avatar>
              <div>
                <div style="margin-bottom: 4px;">{{ realname }}</div>
                <div>{{ phone }}</div>
              </div>
            </div>
            <div class="w-full">
              <div class="w-full">
                <!-- <div v-if="administrationFlag" class="pop-item text-center cursor-pointer" @click="setup(1)">用户管理</div> -->
                <div class="pop-item text-center cursor-pointer" @click="setup(9)">团队移交</div>
                <div class="pop-item text-center cursor-pointer" @click="setup(2)">修改密码</div>
                <!-- <div class="pop-item text-center cursor-pointer" @click="setup(3)">发起邀请</div> -->
                <div class="pop-item text-center cursor-pointer" @click="checkOrder">订单管理</div>
                <div class="pop-item text-center cursor-pointer" @click="checkCoupon">优惠券</div>
                <div class="pop-item text-center cursor-pointer" @click="logout">退出登录</div>
              </div>
            </div>
          </div>
        </div>
      </el-popover>
    </div>
    
    <!-- 福利弹窗 -->
    <div class="welfare-dialog-overlay" v-if="showWelfareDialog" @click.self="closeWelfareDialog">
      <div class="welfare-dialog">
        <!-- 关闭按钮 -->
        <div class="welfare-dialog-close" @click="closeWelfareDialog"></div>
        <!-- 弹窗内容区域，可以在这里添加具体内容 -->
        <div class="welfare-dialog-content relative">
          <div class="welfare-dialog-btn absolute" v-if="trialType === '1'" @click="handleObtainTrial">立即领取</div>
          <div class="welfare-dialog-btn btn-disabled absolute" v-else-if="trialType === '2'">已领取</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, posts } from "@/utils/http.js";
export default {
  props: {
    administrationFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imageUrl: "",
      userInfo: "",
      realname: "",
      username: "",
      phone: "",
      // administrationFlag: false,
      notNumber: null,
      fiveBodyId: null,
      showWelfareDialog: false, // 控制福利弹窗显示
      trialType: '1', // 用户的试用类型：1-未领取，2-已领取
    };
  },
  computed: {

  },
  watch: {
    // 监听弹窗显示状态，当弹窗打开时获取最新的 trialType
    showWelfareDialog(newVal) {
      if (newVal) {
        this.getTrialType()
      }
    }
  },
  mounted() {

  },
  created() {
    const userInfo = JSON.parse(sessionStorage.getItem("currentUser"))
    this.userInfo = userInfo
    this.realname = userInfo.realname
    this.phone = userInfo.phone

    // const fiveBody = JSON.parse(sessionStorage.getItem("fiveBody"))
    // this.fiveBodyId = fiveBody.id

    // this.getNotItem()
  },
  methods: {
    checkOrder() {
      this.$router.push("/orderAdmin");
    },
    checkCoupon() {
      this.$router.push("/couponAdmin");
    },
    logout() {
      sessionStorage.clear();
      this.$router.push("/");
      console.log("退出登录");
    },
    setup(index) {
      this.$emit('setup', index)
    },
    getNotItem() {
      const query = {}
      query.companyId = sessionStorage.getItem('companyId')
      get("/loginInfo/getNotHandedOver", query).then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.notNumber = res.data == 0 ? null : res.data
        } else {
          this.notNumber = null
        }
      })
    },
    // 获取用户的试用类型
    getTrialType() {
      try {
        const userInfo = JSON.parse(sessionStorage.getItem("currentUser") || '{}')
        this.trialType = userInfo.trialType || '1' // 默认为1（未领取）
      } catch (e) {
        console.error('读取用户信息失败:', e)
        this.trialType = '1' // 默认为1（未领取）
      }
    },
    // 关闭福利弹窗
    closeWelfareDialog() {
      this.showWelfareDialog = false
    },
    // 领取试用资格
    handleObtainTrial() {
      const groupInfo = JSON.parse(sessionStorage.getItem('groupInfo') || '{}')
      const groupId = groupInfo.id
      
      if (!groupId) {
        this.$message.error('获取团队信息失败，请刷新页面重试')
        return
      }
      
      posts('/order/obtainTrialQualification', { groupId }).then(res => {
        if (res.code === 200) {
          // 更新 sessionStorage 中的 trialType 为 2（已领取）
          try {
            const userInfo = JSON.parse(sessionStorage.getItem("currentUser") || '{}')
            userInfo.trialType = '2'
            sessionStorage.setItem("currentUser", JSON.stringify(userInfo))
            // 同步更新组件中的 trialType
            this.trialType = '2'
          } catch (e) {
            console.error('更新用户信息失败:', e)
          }
          
          this.$message.success('领取成功')
          this.closeWelfareDialog()
          // 通知父组件领取成功，需要刷新用户团队信息
          this.$emit('obtain-success')
        } else {
          this.$message.error(res.msg || '领取失败，请重试')
        }
      }).catch(err => {
        console.error('领取试用资格失败:', err)
        this.$message.error(err.msg || '领取失败，请重试')
      })
    }
  },
};
</script>
<style lang="less" scoped>
.right-header {
  position: absolute;
  top: 40px;
  right: 40px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 16px;

  .header-banner {
    width: 408px;
    margin-right: 24px;
    transition: all 0.3s;
    &:hover {
      transform: scale(1.05);
    }
  }

  .test {
    overflow: hidden;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .btn-warp {
      width: 107px;
      height: 40px;
      cursor: pointer;
      border-radius: 21px;
      text-align: center;
      line-height: 40px;
      transition: all 0.3s;
      margin-right: 1rem;
      background: rgba(24, 144, 255, 0.1);

      .btn-item {
        color: #d8d8d8 !important;
      }
    }

    .btn-warp-active {
      background: rgba(24, 144, 255);

      .btn-item {
        color: #ffffff !important;
      }
    }

    .btn-warp:hover {
      background: rgba(24, 144, 255);

      .btn-item {
        color: #ffffff !important;
      }
    }

    .back-home {
      min-width: 4rem;
      cursor: pointer;
      font-weight: 400;
      color: #a3a3a3;
      margin-right: 2rem;
    }

    .back-home:hover {
      color: #ffffff;
    }
  }

  i {
    color: #ffffff;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    margin-right: 2rem;
  }

  i:hover {
    color: #0080ff;
  }
}

.u-name {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 30px;
}

.header-info {
  padding: 12px;
  background: #073061;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.pop-item {
  padding: 14px 0;
}

.pop-item:hover {
  background: #1890FF;
}

/* 福利弹窗样式 */
.welfare-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.welfare-dialog {
  position: relative;
  width: 860px;
  height: 560px;
  background: url('@/assets/img/welfare-free-dialog-bg.png') no-repeat center center;
  background-size: 100% 100%;
  border-radius: 20px;
  box-sizing: border-box;
}

.welfare-dialog-close {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  
  i {
    font-size: 24px;
    color: #ffffff;
    transition: all 0.3s;
  }
  
  &:hover i {
    color: #0080ff;
    transform: rotate(90deg);
  }
}

.welfare-dialog-content {
  width: 100%;
  height: 100%;
  min-height: 420px;
  .welfare-dialog-btn {
    width: 357px;
    height: 48px;
    background: linear-gradient( 90deg, #3DA4FE 0%, #2278EB 100%);
    border-radius: 8px;
    font-weight: 600;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
    bottom: 84px;
    left: 50%;
    transform: translateX(-50%);
    &:hover {
      background: linear-gradient( 90deg, #2278EB 0%, #3DA4FE 100%);
    }
  }
  .btn-disabled {
    background: #E6E6E6;
    color: #333333;
    cursor: not-allowed;
    &:hover {
      background: #E6E6E6;
      color: #333333;
    }
  }
}
</style>